<dx-file-uploader [multiple]="false"
                    uploadMode="instantly"
                    [uploadUrl]="getUploadUrl()"
                    [visible]="true"
                    [allowedFileExtensions]="allowedFileExtensions.length > 0 ? allowedFileExtensions : []"
                    (onValueChanged)="fileOnValueChanged($event)"
                    (onBeforeSend)="fileOnBeforeSend($event)"
                    (onUploaded)="fileOnUploaded($event)">
</dx-file-uploader>